import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p>We respect your privacy. Any personal data collected during orders (such as name, address, phone, and email) is used only for order fulfillment and communication.</p>
      <p>We do not share your information with any third parties except our trusted delivery and payment partners.</p>
      <p>Payments are processed securely via Razorpay.</p>
    </div>
  );
}
